import { Box, Button, Paper, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import { GstSchema } from "../formikSchema";
import { fetchGSTDetailsAPI } from "../redux/service/apiEndPoints";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@store/store";
import { fetchGSTDetailsThunk } from "../redux/thunk/registerThunk";
import { toast } from "react-toastify";
import Header from "@components/Header/Header";
import bgImage from "../../../assets/images/BG.svg";
import Introduction from "../components/introduction";
import OrganisationDetails from "./organisationDetails";
import { StyledTextField } from "@components/CustomInput/customInput";


const VerifyGST = () => {

  const dispatch = useDispatch<AppDispatch>();
  const [showOrgDetails, setShowOrgDetails] = React.useState(true);

  const formik = useFormik({
    initialValues: {
      gstNumber: "",
    },
    validationSchema: GstSchema,
    onSubmit: async (values) => { 
      const response = await dispatch(
        fetchGSTDetailsThunk({ gst_number: values.gstNumber })
      );
      if (
        response.meta.requestStatus === "fulfilled" &&
        !response.payload.status
      ) { 
        // onNext();
        setShowOrgDetails(false);
      } else {
        console.error("Failed to fetch GST details:", response);
        toast.error("Something Went Wrong!");
      }
    },
  });
  return (
    <Box className="login-root" style={{ backgroundImage: `url(${bgImage})` }}>
      <Box className="page-content">
        {/* <Header /> */}
        <Box
          sx={{
            mt: 4,
            display: { md: "flex", xs: "block" },
            alignItems: { md: "baseline", xs: "stretch" },
          }}
        >
          <Introduction />
          {
            showOrgDetails ?
              <form action="submit" onSubmit={formik.handleSubmit}>
                <Box>
                  {/* Main Box */}
                  <Box
                    display="flex"
                    justifyContent="center"
                    sx={{ mt: { xs: 4, md: 0 }, px: { xs: 0, lg: 4 } }}
                  >
                    <Paper elevation={3} className="login-box pb-4 mb-4">
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "24px",
                          pb: 3,
                        }}
                      >
                        Your GST Number
                      </Typography>
                      <Box>
                        <Typography
                          component="label"
                          htmlFor="aadhaar"
                          className="aadhaar-register-label"
                        >
                          Enter Business GST Number
                          <span className="required-field">*</span>
                        </Typography>

                        <StyledTextField
                          required
                          type="text"
                          InputProps={{
                            inputProps: {
                              style: {
                                // For Chrome, Safari, Edge, Opera
                                appearance: "textfield",
                                MozAppearance: "textfield",
                              },
                            },
                            sx: {
                              "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                              {
                                WebkitAppearance: "none",
                                margin: 0,
                              },
                            },
                          }}
                          sx={{
                            marginBottom: 0,
                          }}
                          fullWidth
                          placeholder="Enter Business GST Number"
                          className="aadhaar-input validation-input"
                          id="gstNumber"
                          name="gstNumber"
                          value={formik.values.gstNumber}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={
                            formik.touched.gstNumber && Boolean(formik.errors.gstNumber)
                          }
                          helperText={formik.touched.gstNumber && formik.errors.gstNumber}
                        />

                        <Box className="btn-wrapper" sx={{ pt: 2, pb: 2 }}>
                          <Button
                            fullWidth
                            className="btnContinue"
                            type="submit"
                            variant="contained"
                            sx={{ mt: 2 }}
                          >
                            Confirm
                          </Button>
                        </Box>
                      </Box>
                    </Paper>
                  </Box>
                </Box>
              </form> : <OrganisationDetails />
          }
        </Box>
      </Box>
    </Box>

  );
};

export default VerifyGST;
